import script from "./Organizations.vue?vue&type=script&setup=true&lang=js"
export * from "./Organizations.vue?vue&type=script&setup=true&lang=js"

import "./Organizations.vue?vue&type=style&index=0&id=1a4b473a&scoped=true&lang=css"
import "./Organizations.vue?vue&type=style&index=1&id=1a4b473a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a4b473a"]])

export default __exports__